'use client';

import useVelocityStore from '../stores/VelocityStore/useVelocityStore';
import useMarkPrice from './useMarkPrice';

/**
 * Mark price for the currently selected market.
 */
const useCurrentMarketMarkPrice = () => {
	const currentMarketId = useVelocityStore((s) => s.selectedMarket.marketId);
	return useMarkPrice(currentMarketId);
};

export default useCurrentMarketMarkPrice;
